module.exports = __webpack_public_path__ + "static/media/tax-reform-2026.693d8408.png";